module.exports = __webpack_public_path__ + "img/levelup_bronze_completed.c28b9e06.svg";